
export const ai_tip_settings_permission= {
    required_permission:['view_tipsettings','add_tipsettings','change_tipsettings','delete_tipsettings',"view_runpodtips","add_runpodtips","change_runpodtips"]
}